import React from 'react';
import { Row, Col, Card, Statistic, Spin } from 'antd';
import { CheckCircleOutlined, WarningOutlined, CloseCircleOutlined, DollarCircleOutlined } from '@ant-design/icons';
import type { SubscriptionSummary } from '../types';

interface Props {
    summaryData?: SubscriptionSummary;
    isLoading: boolean;
}

export const SubscriptionSummaryCards: React.FC<Props> = ({ summaryData, isLoading }) => {
    if (isLoading) return <Spin size="large" />;

    return (
        <Row gutter={16} style={{ marginBottom: 24 }}>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="Active Subscriptions"
                        value={summaryData?.active_subscriptions || 0}
                        valueStyle={{ color: '#10b981' }}
                        prefix={<CheckCircleOutlined />}
                    />
                </Card>
            </Col>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="In Grace Period"
                        value={summaryData?.grace_period_subscriptions || 0}
                        valueStyle={{ color: '#f59e0b' }}
                        prefix={<WarningOutlined />}
                    />
                </Card>
            </Col>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="Failed Renewals"
                        value={summaryData?.failed_renewals || 0}
                        valueStyle={{ color: '#ef4444' }}
                        prefix={<CloseCircleOutlined />}
                    />
                </Card>
            </Col>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="Pending Value"
                        value={(summaryData?.pending_amount || 0) / 100}
                        precision={2}
                        valueStyle={{ color: '#3b82f6' }}
                        prefix={<DollarCircleOutlined />}
                    />
                </Card>
            </Col>
        </Row>
    );
};
